import React from 'react';
import { Link } from 'react-router-dom';
import BrandMark from '../brand/BrandMark';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-white border-t border-surface-200 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <BrandMark variant="vertical" className="h-24 w-auto mb-4" />
            <p className="text-surface-600 mb-4 max-w-md text-sm">
              Plataforma segura de intercambio y subasta de entradas deportivas.
              Conectamos compradores con vendedores verificados bajo custodia escrow.
            </p>
            <p className="text-xs text-surface-500">
              Datos almacenados en la UE · Pagos procesados por Stripe
            </p>
          </div>

          <div>
            <h3 className="text-lg font-display font-semibold mb-4 text-primary-900">Enlaces</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="text-surface-600 hover:text-gold-700">Inicio</Link></li>
              <li><Link to="/auctions" className="text-surface-600 hover:text-gold-700">Subastas</Link></li>
              <li><Link to="/matches" className="text-surface-600 hover:text-gold-700">Partidos</Link></li>
              <li><Link to="/requests/create" className="text-surface-600 hover:text-gold-700">Solicitar Entradas</Link></li>
              <li><Link to="/sobre-nosotros" className="text-surface-600 hover:text-gold-700">Sobre Nosotros</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-display font-semibold mb-4 text-primary-900">Legal y Soporte</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/ayuda" className="text-surface-600 hover:text-gold-700">Centro de Ayuda</Link></li>
              <li><Link to="/legal/terminos" className="text-surface-600 hover:text-gold-700">Términos de Servicio</Link></li>
              <li><Link to="/legal/privacidad" className="text-surface-600 hover:text-gold-700">Política de Privacidad</Link></li>
              <li><Link to="/legal/cookies" className="text-surface-600 hover:text-gold-700">Política de Cookies</Link></li>
              <li><Link to="/legal/aviso" className="text-surface-600 hover:text-gold-700">Aviso Legal</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-8 pt-8 border-t border-surface-200 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-surface-500 text-sm">
            © {currentYear} Tickets Exchange. Todos los derechos reservados.
          </p>
          <div className="flex flex-wrap items-center gap-4 text-sm">
            <Link to="/legal/cookies" className="text-surface-500 hover:text-gold-700">Cookies</Link>
            <Link to="/legal/aviso" className="text-surface-500 hover:text-gold-700">Aviso Legal</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
